// import EcsAgentStatsMath from '@/components/ecs-agent-stats/EcsAgentStats.math';
import BusinessProcess from '@/classes/BusinessProcess';
import AgentStats from '@/classes/AgentStats';

const AGENTS_STATS = state => state.AGENTS || [];

const BUSINESS_PROCESSES_STATS = (state, getters, rootState, rootGetters) => {
  if (!rootGetters['AGENT/loggedInAgent']) {
    return [];
  }
  const assignedBPs = rootGetters['AGENT/loggedInAgent'].assignedBusinessProcessIds;
  const onlyAssignedBPs = bp => assignedBPs.includes(bp.businessProcessId);
  return state.BUSINESS_PROCESSES.filter(onlyAssignedBPs);
};

const SUPERVISED_BUSINESS_PROCESSES_STATS = (state, getters, rootState, rootGetters) => {
  const supervisedBpsOnly = bp =>
    rootGetters['BUSINESS_PROCESSES/supervisedBusinessProcesses']
      .map(bp => bp.businessProcessId)
      .includes(bp.businessProcessId);
  return state.BUSINESS_PROCESSES.filter(supervisedBpsOnly);
};

const getBusinessProcessStatsById = state => businessProcessId => {
  const bp = state.BUSINESS_PROCESSES.find(bp => bp.businessProcessId === businessProcessId);
  return bp ? new BusinessProcess(bp) : null;
};

const getAgentStatsById = state => agentId => {
  const agentStats = state.AGENTS.find(agent => agent.agentId === agentId);
  return agentStats ? new AgentStats(agentStats) : null;
};

const getBusinessProcessesStats = state => state.BUSINESS_PROCESSES;

const agentsLastUpdate = state => state.agentsLastUpdate;
const bpsLastUpdate = state => state.bpsLastUpdate;

const loggedInAgentStats = (state, getters, rootState, rootGetters) => {
  return state.AGENTS.find(agent => agent.agentId === rootGetters['AGENT/loggedInAgent'].id) || {};
};

const lastKnownAgentStateChange = state => state.lastKnownAgentStateChange;

const getSubscribedCounters = state => state.subscribedCounters;

const getSubscribedCounter = state => ({ counterTypeId, handlerId, dimensionId }) => {
  if (!state.subscribedCounters[counterTypeId]) {
    return null;
  }

  if (state.subscribedCounters[counterTypeId][handlerId]) {
    if (dimensionId) {
      return state.subscribedCounters[counterTypeId][handlerId][dimensionId].value;
    } else {
      return state.subscribedCounters[counterTypeId][handlerId].value;
    }
  }
};

export default {
  AGENTS_STATS,
  BUSINESS_PROCESSES_STATS,
  SUPERVISED_BUSINESS_PROCESSES_STATS,
  loggedInAgentStats,
  agentsLastUpdate,
  bpsLastUpdate,
  getBusinessProcessesStats,
  getBusinessProcessStatsById,
  getAgentStatsById,
  getSubscribedCounter,
  getSubscribedCounters,
  lastKnownAgentStateChange
};
